export function initCookies() {
    function setCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        } else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        setCookie(name, "", -1);
    }

    const children = document.querySelector(".app-block-cookies");
    children.addEventListener("click", function (e) {
        e.preventDefault();
        const parent = this.parentNode.parentNode; // Изменение строки
        parent.classList.toggle('d-none'); // Изменение строки
        const blockCookies = document.querySelector(".block-cookies");
        blockCookies.classList.add('d-none');
        setCookie('children', 1, 30);
    });

    if (!getCookie('children')) {
        $('.block-cookies').removeClass('d-none');
    }
}